<!-- 
	OptinForm
	props: User
  	role: User
	Called by @/components/EmailVerificationComponent to allow user to register/create account
	Does not include any ticket package options
-->

<template>
  <p style="color: red;">
    Error when creating profile. The information submitted does not match our records. Please contact customer support for further assistance.
  </p>
</template>
	
	<script>
	  import { onMounted } from "@vue/runtime-core";
	
	  import CustomButton from "@/components/CustomButton";
	  import Loading from "@/components/Loading";
	
	
	  export default {
		name: "OptinForm",
		components: {
		  CustomButton,
		  Loading,
		},
		props: ["user"],
		setup() {
		  onMounted(() => {
			// ClickSpace form requirement
			DI.Forms.Optin.Dom.onReady(function () {
					DI.Forms.Optin.Client.InitOptinForm({
						formIdent: 'DIForm_709_27381',
						culture: 'en-US',
						idBaseDiv: 'divForm_DIForm_709_27381',
						recaptchaSiteKey: '',
						fields: [
							{"name":"f_NewMainTicketPackage","lbl":"Select Your New Main Ticket Package","id":"DIField_27381_f_NewMainTicketPackage","validators":[],"inputType":"radio"},
							{"name":"f_New5050TicketPackage","lbl":"Select Your New 50/50 Ticket Package","id":"DIField_27381_f_New5050TicketPackage","validators":[],"inputType":"radio"},
							{"name":"f_DeductionCodeMainNew","lbl":"Deduction Code Main - New","id":"DIField_27381_f_DeductionCodeMainNew","validators":[]},
							{"name":"f_DeductionCode5050New","lbl":"Deduction Code 5050 - New","id":"DIField_27381_f_DeductionCode5050New","validators":[]},
							{"name":"f_EmployeeID","lbl":"Employee ID","id":"DIField_27381_f_EmployeeID","validators":["required"]},
							{"name":"f_FirstName","lbl":"First Name","id":"DIField_27381_f_FirstName","validators":[]},
							{"name":"f_LastName","lbl":"Last Name","id":"DIField_27381_f_LastName","validators":[]},
							{"name":"f_HomeAddress","lbl":"Home Address","id":"DIField_27381_f_HomeAddress","validators":["required"]},
							{"name":"f_City","lbl":"City","id":"DIField_27381_f_City","validators":["required"]},
							{"name":"f_PostalCode","lbl":"Postal code","id":"DIField_27381_f_PostalCode","validators":[]},
							{"name":"f_MobilePhone","lbl":"Mobile phone","id":"DIField_27381_f_MobilePhone","validators":[]},
							{"name":"f_HomePhone","lbl":"Home phone","id":"DIField_27381_f_HomePhone","validators":[]},
							{"name":"f_EMail","lbl":"EMail","id":"DIField_27381_f_EMail","validators":["required","email"]},
							{"name":"f_AlternateEmail","lbl":"Alternate Email","id":"DIField_27381_f_AlternateEmail","validators":["email"]},
							{"name":"f_PayrollSelection","lbl":"Payroll Selection","id":"DIField_27381_f_PayrollSelection","validators":[],"inputType":"radio"},
							{"name":"f_NewDesignation","lbl":"Select Your New Designation","id":"DIField_27381_f_NewDesignation","validators":["required"],"inputType":"select"}
						],
						fieldValues: {},
						errorMessages: {"general":"Error in form.","required":"The field {0} is required.","dataType":"The datatype for {0} is invalid.","min":"The minimum value for {0} is {1}.","max":"The maximum value for {0} is {1}.","interval":"The value for {0} must be between {1} and {2}.","inputMask":"The value for {0} does not match the input format.","updateDupeKey":"Update could not be performed as this identifier already exists.","checkInlineErrors":"Please correct the errors below."} ,
						idSuccessDiv: 'divForm_DIForm_709_27381_success',
						mode: DI.Forms.Optin.Client.EnumOptinMode.Optin,
						url: '//app.dialoginsight.com/A/WF.ashx',
						idWorkflow: 23377,
						wfKey: 'klOKyo',
						nodeKey: 'Optin',
						visible: true
							
					});
				});
			  
		  });
		},
		data() {
			return {
				selectionMain: "",
				selection50: "",
				selectionBundle: "",
				loading: false,
				timer: false,
			};
		},
		computed: {
		  selectionTotal: function() {
			return Number(this.selectionMain) + Number(this.selection50);
		  },
		  selectionMainTicket: function() {
			if (this.selectionMain == "10") {
			  return "1";
			}
			else if (this.selectionMain == "20") {
			  return "5";
			}
			else if (this.selectionMain == "30") {
			  return "10";
			}
			else if (this.selectionMain == "40") {
			  return "20";
			}
			else if (this.selectionMain == "35") {
			  return "20";
			}
			else {
			  return "0";
			} 
		  },
		  selection50Ticket: function() {
			if (this.selection50 == "5") {
			  return "1";
			}
			else if (this.selection50 == "15") {
			  return "5";
			}
			else if (this.selection50 == "10") {
			  return "5";
			}
			else if (this.selection50 == "25") {
			  return "10";
			}
			else if (this.selection50 == "17.50") {
			  return "10";
			}
			else if (this.selection50 == "35") {
			  return "20";
			}
			else if (this.selection50 == "30") {
			  return "20";
			}
			else {
			  return "0";
			}
		  },
		  deductionCodeMain: function() {
			if (this.selectionMain == "10") {
			  return "WIN3";
			}
			else if (this.selectionMain == "20") {
			  return "WIN8";
			}
			else if (this.selectionMain == "30") {
			  return "WIN15";
			}
			else if (this.selectionMain == "35") {
			  return "WIN1";
			}
			else if (this.selectionMain == "40") {
			  return "WIN40";
			}
			else {
			  return "";
			}
		  },
		  deductionCode50: function() {
			if (this.selection50 == "") {
			  return "";
			}
			else {
			  return "WIN50";
			}
		  },
  
		},
		methods: {
			loadUser() {
				// load user on action after delaying 5 seconds for ClickSpace webhook/API communication
				this.loading = true;
				setTimeout(() => {
					this.timer = true;
					this.loading = false;
					return (window.location.href = "/user");
				}, 5000);
			},
		  clearMainSelection: function() {
			this.selectionMain = "";
		  },
		  clear50Selection: function() {
			this.selection50 = "";
		  },
		  clearBothSelection: function() {
			this.selectionMain = "";
			this.selection50 = "";
			this.selectionBundle = "";
		  },
		  clearBundleSelection: function() {
			this.selectionBundle = "";
			if ((this.selectionMain=="20") && (this.selection50=="10")) {
			  this.selectionMain = "";
			  this.selection50 = "";
			}
			if ((this.selectionMain=="30") && (this.selection50=="17.50")) {
			  this.selectionMain = "";
			  this.selection50 = "";
			}
			if ((this.selectionMain=="35") && (this.selection50=="30")) {
			  this.selectionMain = "";
			  this.selection50 = "";
			}
		  },
		  bundle0Handler: function() {
			this.selectionMain = "20";
			this.selection50 = "10";
		  },
		  bundle1Handler: function() {
			this.selectionMain = "30";
			this.selection50 = "17.50";
		  },
		  bundle2Handler: function() {
			this.selectionMain = "35";
			this.selection50 = "30";
		  },
		  bundleComponentValidationHandler: function() {
			//console.log(this.selectionMain);
			//console.log(this.selection50);
			if (!(((this.selectionMain == "20") && (this.selection50 == "10")) || ((this.selectionMain == "30") && (this.selection50 == "17.50")) ||((this.selectionMain == "35") && (this.selection50 == "30")))) {
			  this.selectionBundle = "";
			  
			  if (this.selectionMain == "35") {
				this.selectionMain = "40";  
			  }
	
			  if (this.selection50 == "10") {
				this.selection50 = "15";
			  }
	
			  if (this.selection50 == "17.50") {
				this.selection50 = "25";
			  }
	
			  if (this.selection50 == "30") {
				this.selection50 = "35";
			  }
	
			}
	
			if ((this.selectionMain == "20") && (this.selection50 == "15")) {
			  this.selectionBundle = "30";
			  this.selection50 = "10";
			}
	
			if ((this.selectionMain == "30") && (this.selection50 == "25")) {
			  this.selectionBundle = "47.50";
			  this.selection50 = "17.50";
			}
	
			if ((this.selectionMain == "40") && (this.selection50 == "35")) {
			  this.selectionBundle = "65";
			  this.selectionMain = "35";
			  this.selection50 = "30";
			}
	
		  },
		  
		},
	  };
	  
	</script>
	
	<style lang="scss">
	  @import "../assets/styles.scss";
	
	
	  //@import "https://winwinstafflottery.ca/enroll/css/bootstrap.css";
	  //@import "https://winwinstafflottery.ca/enroll/css/enrollment2023.css";
	  //@import "https://winwinstafflottery.ca/enroll/css/responsive.css";
	
	 // @import "https://winwinstafflottery.ca/enroll/css/custom2023.css?v=1.4>";
	  
	/*
	  @import "https://use.typekit.net/itr6qee.css";
	  @import "https://winwinstafflottery.ca/enroll/css/bootstrap.css";
	  @import "https://winwinstafflottery.ca/enroll/style.css?v=<?=time();?>";
	  @import "https://winwinstafflottery.ca/enroll/css/swiper.css";
	  @import "https://winwinstafflottery.ca/enroll/css/dark.css";
	  @import "https://winwinstafflottery.ca/enroll/css/font-icons.css";
	 
	  @import "https://winwinstafflottery.ca/enroll/css/animate.css";
	  @import "https://winwinstafflottery.ca/enroll/css/magnific-popup.css";
	  @import "https://winwinstafflottery.ca/enroll/css/custom2023.css?v=1.4>";
	*/
	
	/*
	  @import "https://winwinstafflottery.ca/enroll/css/table.css";
	  @import "https://winwinstafflottery.ca/enroll/css/colors.css";
	  @import "https://winwinstafflottery.ca/enroll/css/enrollment2023.css";
	  @import "https://winwinstafflottery.ca/enroll/css/responsive.css";
	
	*/
	
	
	.message-order-form {
		text-align: left;
		line-height: 1.8;
		font-size: 80%;
    	font-weight: 400;
		margin-bottom: 30px;
		margin-top: 0;
		color: #555;
	}

	.heading-order-form {
		font-weight: 500!important;
		text-align: center !important;
		font-size: 1.5rem;
		color: #444;
		line-height: 1.5;
    	margin: 0 0 30px 0;
    	font-family: 'Poppins', sans-serif;
	}
	.pricing-price {
	  position: relative;
	  padding: 1.5rem 0;
	  color: #333;
	  font-size: 2.5rem;
	  line-height: 1;
	}
	
	/*
	.pricing-price .price-unit {
	  display: inline-block;
	  vertical-align: top;
	  margin: 7px 3px 0 0;
	  font-size: 28px;
	  font-weight: normal;
	}
	
	.pricing-price .price-tenure {
	  vertical-align: baseline;
	  font-size: 1rem;
	  font-weight: normal;
	  letter-spacing: 1px;
	  color: #999;
	  margin: 0 0 0 3px;
	}
	*/
	
	.pricing-extended {
	  background-color: #FFF;
	  text-align: left;
	}
	
	.pricing-extended .pricing-title {
	  background-color: transparent;
	  padding-top: 0;
	}
	
	.pricing-extended .pricing-features {
	  border: 0;
	  background-color: transparent;
	}
	
	.pricing-extended .pricing-action-area {
	  border-left: 1px solid rgba(0,0,0,0.05);
	  background-color: #F9F9F9;
	  padding: 30px;
	  text-align: center;
	}
	
	.pricing-extended .pricing-action-area .pricing-price,
	.pricing-extended .pricing-action-area .pricing-action { padding: 0; }
	
	.pricing-extended .pricing-action-area .pricing-price { padding-bottom: 20px; }
	
	.pricing-extended .pricing-action-area .pricing-price::after { display: none; }
	
	.pricing-extended .pricing-action-area .pricing-price span.price-tenure {
	  display: block;
	  margin: 10px 0 0 0;
	  font-weight: 300;
	  text-transform: uppercase;
	  font-size: 0.875rem;
	}
	
	.pricing-extended .pricing-meta {
	  color: #999;
	  font-weight: 300;
	  font-size: 0.875rem;
	  letter-spacing: 1px;
	  text-transform: uppercase;
	  padding-bottom: 10px;
	}
	
	.pricing-box {
	  border-color: rgba(255,255,255,0.1);
	  background-color: rgb(231, 214, 164);
	  box-shadow: 0 1px 1px rgba(0,0,0,0.1);
	  padding: 10px;
	}
	
	.header-summary {
	  font-weight: 600!important;
	  line-height: 1!important;
	  font-size: 30px;
	  margin: 0 0 30px;
	  font-family: poppins,sans-serif;
	}
	
	.button-submit {
			background-color: #ffd36c!important;
			color: #E5D876;
			font-weight: 700;
			text-transform: uppercase;
			letter-spacing: 1px;
			border: 1px #1a1f56 solid;
			text-shadow: 0px 0px 0px rgb(0 0 0 / 20%);
		  }
	
		  .button-submit:hover {
	/*				background-color: #1a1f56!important;*/
			color: #33ccff!important;
			box-shadow: var(--shadow-elevation-medium);
		  }
	
	.button-clear {
			display: inline-block;
			position: relative;
			cursor: pointer;
			outline: none;				
			margin: 5px;
			padding: 0 22px;
			font-size: 14px;				
			line-height: 36px;
			font-weight: 500;
			text-transform: uppercase;
			text-align: center!important;
			letter-spacing: 1px;
			border: 1px #E5D876 solid;
			text-shadow: 0px 0px 0px rgb(0 0 0 / 20%);
		  }
		  .button-clear:hover {
	/*				background-color: #1a1f56!important;*/
			color: #33ccff!important;
			box-shadow: var(--shadow-elevation-medium);
		  }
	
		  /*
		  .clearSelection {
			text-transform: uppercase;
			background-color: #eaeaea;
			cursor: pointer;
			box-shadow: var(--shadow-elevation-low);
		  }
	
		  .clearSelection:hover, .process-btn:hover {
			background-color: #1a1f56!important;
			color: #eaeaea!important;
			box-shadow: var(--shadow-elevation-medium);
		  }
	
		  */
	
	
	.bg-gradient-royal { background: linear-gradient(125deg, #1A1F56, #040707, #1A1F56)!important; border: 2px solid #ffd36c; padding: 30px !important; margin-bottom: 50px; box-shadow: 0px 0px 50px 0px rgb(0 0 0 / 50%);}
	
	
	.bg-gradient-db2 { background: linear-gradient(115deg,rgba(153,135,95,1) 0%,rgba(231,214,164,1) 50%,rgba(169,151,109,1) 100%)!important; border: 2px solid #ffd36c;padding: 30px !important; margin-bottom: 50px; box-shadow: 0px 0px 50px 0px rgb(0 0 0 / 50%);}
	.bg-gold-ombre2 { background: rgb(153,153,102); background: linear-gradient(105deg, rgba(153,135,95,1) 0%, rgba(231,214,164,1) 50%, rgba(169,151,109,1) 100%); }
	.bg-gradient-qc { background: linear-gradient(125deg, #d3d2cd, #e3e4de, #fdfdfd, #e3e4de, #d3d2cd)!important; border: 2px solid #ffd36c;padding: 30px !important; margin-bottom: 50px; box-shadow: 0px 0px 50px 0px rgb(0 0 0 / 50%);}
	
	
	.bg-gradient-db { background: linear-gradient(115deg,rgba(245,228,177,1) 0%,rgba(153,135,95,1) 51%,rgba(231,214,164,1) 80%,rgba(169,151,109,1) 100%)!important; border: 2px solid #ffd36c;padding: 30px !important; margin-bottom: 50px; box-shadow: 0px 0px 50px 0px rgb(0 0 0 / 50%);}
	.bg-gradient-db3 { background: linear-gradient(115deg,#e4d8be, #c7c4a6, #e4d8be, #cac9af, #e4d8be)!important; border: 2px solid #ffd36c;padding: 30px !important; margin-bottom: 50px; box-shadow: 0px 0px 50px 0px rgb(0 0 0 / 50%);}
	.bg-gradient-of { background: linear-gradient(#FFD36C87, #FFFFFF87);}
	
	.gold-ombre { background: -webkit-linear-gradient(105deg, rgba(153,153,102,1) 0%, rgba(245,228,177,1) 27%, rgba(153,135,95,1) 51%, rgba(231,214,164,1) 80%, rgba(169,151,109,1) 100%);  -webkit-background-clip: text;  -webkit-text-fill-color: transparent; }
	 
	
		.flex-container {
		  display: flex;
		  flex-direction: row;
		}
	
		.flex-container2 {
		  display: flex;
		  flex-direction: row;
		}
	
		
		@media (max-width: 800px) {
		  .flex-container {
			flex-direction: column;
		  }
	
		  .flex-container2 {
			flex-direction: column;
		  }
		}
	
		.sticky { 
		  position: sticky; 
		  top: 0; 
		  margin-bottom: auto;
		}
	
	
		.royal {
		color: #1a1f56!important;
		}
	
		.bundle-header {
		  font-size: 30px;
		  font-weight: 600;
		  line-height: 1.5;
		  margin: 0 0 30px 0;
		  font-family: 'Poppins', sans-serif;
		}
		
		.bg-royal {
		  background-color: #1a1f56!important;
		}
	
		/*
	
		.text-center {
		  text-align: center!important;
		}
		
		*/
	
		.card {
		  font-family: poppins,sans-serif;
		  color: #1a1f56;
		  font-weight: 400;
		}
	
		
		.card-header {
		  padding: 0.75rem 1.25rem;
		  margin-bottom: 0;
		  border-bottom: 1px solid rgba(0,0,0,.125);
		}   
	
		.card-title {
		  margin-bottom: 0.75rem;
		}
	
		h4 {
		  font-weight: 600;
		  font-size: 18px;
		}
	
	
		:root {
	  --blue: #007bff;
	  --indigo: #6610f2;
	  --purple: #6f42c1;
	  --pink: #e83e8c;
	  --red: #dc3545;
	  --orange: #fd7e14;
	  --yellow: #ffc107;
	  --green: #28a745;
	  --teal: #20c997;
	  --cyan: #17a2b8;
	  --white: #fff;
	  --gray: #6c757d;
	  --gray-dark: #343a40;
	  --primary: #007bff;
	  --secondary: #6c757d;
	  --success: #28a745;
	  --info: #17a2b8;
	  --warning: #ffc107;
	  --danger: #dc3545;
	  --light: #f8f9fa;
	  --dark: #343a40;
	  --breakpoint-xs: 0;
	  --breakpoint-sm: 576px;
	  --breakpoint-md: 768px;
	  --breakpoint-lg: 992px;
	  --breakpoint-xl: 1200px;
	  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
	  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
	}
	
	
	.card {
	  position: relative;
	  display: -ms-flexbox;
	  display: flex;
	  -ms-flex-direction: column;
	  flex-direction: column;
	  min-width: 0;
	  word-wrap: break-word;
	  background-color: #fff;
	  background-clip: border-box;
	  border: 1px solid rgba(255, 211, 108, 1);
	  border-radius: 0.25rem;
	}
	
	.card > hr {
	  margin-right: 0;
	  margin-left: 0;
	}
	
	.card > .list-group:first-child .list-group-item:first-child {
	  border-top-left-radius: 0.25rem;
	  border-top-right-radius: 0.25rem;
	}
	
	.card > .list-group:last-child .list-group-item:last-child {
	  border-bottom-right-radius: 0.25rem;
	  border-bottom-left-radius: 0.25rem;
	}
	
	.card-body {
	  -ms-flex: 1 1 auto;
	  flex: 1 1 auto;
	  padding: 1.25rem;
	}
	
	.card-title {
	  margin-bottom: 0.75rem;
	}
	
	.card-subtitle {
	  margin-top: -0.375rem;
	  margin-bottom: 0;
	}
	
	.card-text:last-child {
	  margin-bottom: 0;
	}
	
	.card-link:hover {
	  text-decoration: none;
	}
	
	.card-link + .card-link {
	  margin-left: 1.25rem;
	}
	
	.card-header {
	  padding: 0.75rem 1.25rem;
	  margin-bottom: 0;
	  background-color: rgba(0, 0, 0, 0.03);
	  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
	}
	
	.card-header:first-child {
	  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
	}
	
	.card-header + .list-group .list-group-item:first-child {
	  border-top: 0;
	}
	
	.card-footer {
	  padding: 0.75rem 1.25rem;
	  background-color: rgba(0, 0, 0, 0.03);
	  border-top: 1px solid rgba(0, 0, 0, 0.125);
	}
	
	.card-footer:last-child {
	  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
	}
	
	.card-header-tabs {
	  margin-right: -0.625rem;
	  margin-bottom: -0.75rem;
	  margin-left: -0.625rem;
	  border-bottom: 0;
	}
	
	.card-header-pills {
	  margin-right: -0.625rem;
	  margin-left: -0.625rem;
	}
	
	.card-img-overlay {
	  position: absolute;
	  top: 0;
	  right: 0;
	  bottom: 0;
	  left: 0;
	  padding: 1.25rem;
	}
	
	.card-img {
	  width: 100%;
	  border-radius: calc(0.25rem - 1px);
	}
	
	.card-img-top {
	  width: 100%;
	  border-top-left-radius: calc(0.25rem - 1px);
	  border-top-right-radius: calc(0.25rem - 1px);
	}
	
	.card-img-bottom {
	  width: 100%;
	  border-bottom-right-radius: calc(0.25rem - 1px);
	  border-bottom-left-radius: calc(0.25rem - 1px);
	}
	
	.card-deck {
	  display: -ms-flexbox;
	  display: flex;
	  -ms-flex-direction: column;
	  flex-direction: column;
	}
	
	.card-deck .card {
	  margin-bottom: 15px;
	}
	
	@media (min-width: 576px) {
	  .card-deck {
		-ms-flex-flow: row wrap;
		flex-flow: row wrap;
		margin-right: -15px;
		margin-left: -15px;
	  }
	  .card-deck .card {
		display: -ms-flexbox;
		display: flex;
		-ms-flex: 1 0 0%;
		flex: 1 0 0%;
		-ms-flex-direction: column;
		flex-direction: column;
		margin-right: 15px;
		margin-bottom: 0;
		margin-left: 15px;
	  }
	}
	
	.card-group {
	  display: -ms-flexbox;
	  display: flex;
	  -ms-flex-direction: column;
	  flex-direction: column;
	}
	
	.card-group > .card {
	  margin-bottom: 15px;
	}
	
	@media (min-width: 576px) {
	  .card-group {
		-ms-flex-flow: row wrap;
		flex-flow: row wrap;
	  }
	  .card-group > .card {
		-ms-flex: 1 0 0%;
		flex: 1 0 0%;
		margin-bottom: 0;
	  }
	  .card-group > .card + .card {
		margin-left: 0;
		border-left: 0;
	  }
	  .card-group > .card:not(:last-child) {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	  }
	  .card-group > .card:not(:last-child) .card-img-top,
	  .card-group > .card:not(:last-child) .card-header {
		border-top-right-radius: 0;
	  }
	  .card-group > .card:not(:last-child) .card-img-bottom,
	  .card-group > .card:not(:last-child) .card-footer {
		border-bottom-right-radius: 0;
	  }
	  .card-group > .card:not(:first-child) {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	  }
	  .card-group > .card:not(:first-child) .card-img-top,
	  .card-group > .card:not(:first-child) .card-header {
		border-top-left-radius: 0;
	  }
	  .card-group > .card:not(:first-child) .card-img-bottom,
	  .card-group > .card:not(:first-child) .card-footer {
		border-bottom-left-radius: 0;
	  }
	}
	
	.card-columns .card {
	  margin-bottom: 0.75rem;
	}
	
	@media (min-width: 576px) {
	  .card-columns {
		-webkit-column-count: 3;
		-moz-column-count: 3;
		column-count: 3;
		-webkit-column-gap: 1.25rem;
		-moz-column-gap: 1.25rem;
		column-gap: 1.25rem;
		orphans: 1;
		widows: 1;
	  }
	  .card-columns .card {
		display: inline-block;
		width: 100%;
	  }
	}
	
	
	
	.center {
	  display: block;
	  margin-left: auto;
	  margin-right: auto;
	  width: 70%;
	}
	
	.center2 {
	  display: block;
	  margin-left: auto;
	  margin-right: auto;
	  width: 50%;
	}
	
	
	
	
	</style>
	